const dimensions = {
    pageDimension: '1200px'
};
      
export default dimensions;